import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cellLabel',
  standalone: true,
})
export class CellLabelPipe implements PipeTransform {
  transform<Entity extends object>(
    label: string | ((entity: Entity) => string),
    entity: Entity
  ): string {
    if (typeof label === 'string') return label;

    return label(entity);
  }
}
